"use strict";
// Configuration for grade reports
// This config should be set by the consuming app (iTeach or iLearn)
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.setConfig = void 0;
// Default config - apps should override this
let config = {
    nodeSiteUrl: '' // Will be set by setConfig()
};
function setConfig(newConfig) {
    config = newConfig;
}
exports.setConfig = setConfig;
function getConfig() {
    if (!config.nodeSiteUrl) {
        console.warn('Grade report config not initialized. Using empty config.');
    }
    return config;
}
exports.getConfig = getConfig;
// Default export for compatibility with dynamic imports
exports.default = {
    nodeSiteUrl: config.nodeSiteUrl,
    get default() {
        return getConfig();
    }
};
